import { MultitrackAudio, Audio } from "@/audio/audio";

function initMetaAudio(json) {
    const basePath = json.basepath;
    if (Array.isArray(json.audio) && json.audio.length > 1) {
        // multitrack
        return new MultitrackAudio(json.audio.map(
            filename => `${basePath}/${filename}`
        ));
    } else {
        return new Audio(`${basePath}/${json.audio}`);
    }
}

export function loadMetadata(json) {
    let meta = {
        ...json
    }
    if (json.audio && json.audio.length != 0) {
        meta.audio = initMetaAudio(json);
    }
    return meta;
}